import { useEffect, useState } from 'react'
import { ClientConcierge } from './features/client/ClientConcierge'
import { StaffDashboard } from './features/staff/StaffDashboard'
import { IS_API_MODE, MockAppStore } from './store/MockAppStore'

const routeFromLocation = () => window.location.pathname.startsWith('/staff') ? 'staff' : 'client'

export default function App() {
  const [route, setRoute] = useState<'client' | 'staff'>(routeFromLocation)
  useEffect(() => {
    const update = () => setRoute(routeFromLocation())
    window.addEventListener('hashchange', update)
    window.addEventListener('popstate', update)
    return () => { window.removeEventListener('hashchange', update); window.removeEventListener('popstate', update) }
  }, [])
  const navigate = (next: 'client' | 'staff') => {
    if (IS_API_MODE && next === 'staff') {
      window.location.assign('/staff')
      return
    }
    window.history.pushState({}, '', next === 'staff' ? '/staff' : '/')
    setRoute(next)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  return <MockAppStore route={route}>{route === 'staff' ? <StaffDashboard goToClient={() => navigate('client')} /> : <ClientConcierge goToStaff={() => navigate('staff')} />}</MockAppStore>
}
